import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import UsersContent from "modules/Users";

import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const UsersPage: React.FC = () => {
  setTitle("User Management");
  return (
    <Auth>
      <Layout>
        <UsersContent />
      </Layout>
    </Auth>
  );
};

export default UsersPage;
